/**
 * @packageDocumentation
 * @module Array
 */
import memoize from 'memoize-one';
/**
 * Private function to order an array according to the orderBy
 * @param a first value to compare
 * @param b second value to compare
 * @param orderBy string with the name of the field to compare
 *
 * @return number
 */
function orderFunc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
var desc = memoize(orderFunc);
function sortFunc(array, cmp) {
    var stabilizedThis = array.map(function (el, index) { return [el, index]; });
    stabilizedThis.sort(function (a, b) {
        var order = cmp(a[0], b[0]);
        if (order !== 0)
            return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(function (el) { return el[0]; });
}
/**
 * Function to sort an array given the array and the compare function
 *
 * @param array initial array to sort
 * @param cmp function to use as a comparison for ordering
 *
 * @return sorted array
 */
export var stableSort = memoize(sortFunc);
function getSortFunc(order, orderBy) {
    return order === 'desc' ? function (a, b) { return desc(a, b, orderBy); } : function (a, b) { return -desc(a, b, orderBy); };
}
/**
 * Function to get the function to sort
 *
 * @param order string to decide if order is `asc` or `desc`
 * @param orderBy field to order by
 *
 * @return sorted function
 */
export var getSorting = memoize(getSortFunc);
//# sourceMappingURL=sorting.js.map